import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faDownload } from "@fortawesome/free-solid-svg-icons";

const InstallationReport = ({ installationList = [], exportUrl, links }) => {

    // Double scroll implementation
    useEffect(() => {
        const element = document.getElementById("doublescroll");
        if (!element) return;

        const scrollbar = document.createElement("div");
        scrollbar.appendChild(document.createElement("div"));
        scrollbar.style.overflow = "auto";
        scrollbar.style.overflowY = "hidden";
        scrollbar.firstChild.style.width = element.scrollWidth + "px";
        scrollbar.firstChild.style.paddingTop = "1px";
        scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));

        let running = false;
        let lastElementLeft = element.scrollLeft;
        let lastScrollbarLeft = scrollbar.scrollLeft;
        scrollbar.onscroll = function () {
            const left = scrollbar.scrollLeft;
            if (left === lastScrollbarLeft) return;
            lastScrollbarLeft = left;
            if (running) {
                running = false;
                return;
            }
            running = true;
            element.scrollLeft = left;
            lastElementLeft = left;
        };
        element.onscroll = function () {
            const left = element.scrollLeft;
            if (left === lastElementLeft) return;
            lastElementLeft = left;
            if (running) {
                running = false;
                return;
            }
            running = true;
            scrollbar.scrollLeft = left;
            lastScrollbarLeft = left;
        };
        element.parentNode.insertBefore(scrollbar, element);
    }, [installationList]);

    return (
        <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
            {/* Breadcrumb and Export */}
            <div className="row pb-2">
                <div className="col-md-6">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="/"><FontAwesomeIcon icon={faArrowUp} /> Home</a>
                        </li>
                        <li className="breadcrumb-item active">Installation Report</li>
                    </ul>
                </div>
                <div className="col-md-6 text-right">
                    <button
                        className="btn btn-default btn-sm ml-1"
                        onClick={() => window.location.href = exportUrl}
                    >
                        <FontAwesomeIcon icon={faDownload} /> Export Report
                    </button>
                </div>
            </div>

            {/* Table */}
            {installationList && installationList.length > 0 ? (
                <div
                    className="table-responsive panel panel-default with-rounded-corner with-shadow p-10"
                    id="doublescroll"
                    style={{ height: "450px", overflowY: "scroll" }}
                >
                    <table className="table table-condensed table-bordered bg-white">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Total Subscriber</th>
                                <th>New Subscriber</th>
                                <th>Old Subscriber</th>
                                <th>Splash Screen</th>
                                <th>Get OTP Screen</th>
                                <th>Submit OTP Screen</th>
                                <th>Free Trial Screen</th>
                                <th>Dashboard First Launch</th>
                            </tr>
                        </thead>
                        <tbody>
                            {installationList.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item.trackdate}</td>
                                    <td>{item.total}</td>
                                    <td>{item.new}</td>
                                    <td>{item.total - item.new}</td>
                                    <td>{item.splashscreen}</td>
                                    <td>{item.getotpscreen}</td>
                                    <td>{item.submitotpscreen}</td>
                                    <td>{item.freetrialscreen}</td>
                                    <td>{item.dashboardscreen}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p>No Records Found</p>
            )}

            {/* Pagination links */}
            {links && <div className="mt-3">{links}</div>}

            {/* Scroll Top Button */}
            <a href="#" className="btn-scroll-top fade"><FontAwesomeIcon icon={faArrowUp} /></a>

            {/* Sticky header CSS */}
            <style>{`
        thead th {
          position: sticky;
          top: -10px;
          background: #ffffff;
          padding-top: 10px !important;
        }
      `}</style>
        </div>
    );
};

export default InstallationReport;
